import { del, get, post } from '@api/api-client';

interface EditionCategoryDetailNameResponse {
  name: string;
  marketplaceId1: number;
  marketplaceId2: number | null;
  marketplaceId3: number | null;
  marketplaceId4: number | null;
  marketplaceId5: number | null;
  marketplaceId6: number | null;
  marketplaceId7: number | null;
  marketplaceId8: number | null;
  marketplaceId9: number | null;
  marketplaceId10: number | null;
}

export interface EditionCategoryDetailResponse {
  id: string;
  editionId: string;
  nomineeCount: number;
  voteCount: number;
  category: {
    id: string;
    name: string;
    isClinic: boolean;
    isGlobal: boolean;
    details: EditionCategoryDetailNameResponse[];
  };
}

export interface EditionCategoryResponse {
  id: string;
  editionId: string;
  categoryId: string;
}

export interface CreateEditionCategoryDTO {
  editionId: string;
  categoryId: string;
}

/** Fetches categories assigned to an edition with full details. */
export function getEditionCategories(editionId: string): Promise<EditionCategoryDetailResponse[]> {
  return get<EditionCategoryDetailResponse[]>(`/editions/${editionId}/categories`);
}

/** Assigns a category to an edition. */
export function createEditionCategory(
  data: CreateEditionCategoryDTO,
): Promise<EditionCategoryResponse> {
  return post<EditionCategoryResponse>('/edition-categories', data);
}

/** Unlinks a category from an edition using edition and category IDs. */
export function unlinkEditionCategory(editionId: string, categoryId: string): Promise<void> {
  return del(`/editions/${editionId}/categories/${categoryId}`);
}
